import { trapFocus } from './focus-trap';
const base_url = $('#base-url').attr('data-url');

const Share = {
    copyLink() {
        $('#share-link').trigger('select');
        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'Copied!' : 'Whoops, not copied!';
            $('.share-link-copied').removeClass('opacity-0');
            setTimeout(function () {
                $('.share-link-copied').addClass('opacity-0');
            }, 1500);
        } catch (err) {}
        $('#share-link').trigger('blur');
    },
    updateModalContent($share_trigger) {
        var $modal = $('#modal-share');

        var title = $share_trigger.data('share-title');
        var link = $share_trigger.data('share-url');

        var subject = $('.email-link').data('subject');
        var message = $('.email-link').data('message');
        var email_appended = false;
        var email_link = 'mailto:';
        if (subject) {
            email_link = email_appended ? email_link + '&' : email_link + '?';
            email_link = email_link + 'Subject=' + subject;
            email_appended = true;
        }

        if (message) {
            email_link = email_appended ? email_link + '&' : email_link + '?';
            email_link = email_link + 'Body=' + message;
            email_appended = true;
        }

        email_link = email_link.replace('%20', ' ');

        $('#share-link').val(link);
        $('.facebook-link', $modal).attr(
            'href',
            'http://www.facebook.com/sharer.php?u=' + encodeURI(link)
        );
        $('.twitter-link', $modal).attr(
            'href',
            'https://twitter.com/share?url=' +
                encodeURI(link) +
                '&amp;text=' +
                encodeURI(title)
        );
        $('.linkedin-link', $modal).attr(
            'href',
            'http://www.linkedin.com/sharing/share-offsite/?mini=true&url=' +
                encodeURI(link)
        );
        $('.email-link', $modal).attr(
            'href',
            email_link + ' ' + encodeURI(link)
        );
        trapFocus(document.getElementById('modal-share'));
    },
    init() {
        $('[data-share]').on('click', function () {
            // toggleModal('modal-share', true);
            Share.updateModalContent($(this));
            return false;
        });

        $('.copy-share-link').on('click', function () {
            Share.copyLink();
            return false;
        });

        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                if (
                    $('#modal-share').length > 0 &&
                    $('#modal-share').is(':visible')
                ) {
                    // toggleModal('modal-share', false);
                }
            }
        });

        // set focus on modal close button click
        $(document).on(
            'click',
            '#modal-share [data-modal-toggle]',
            function (event) {
                window.setTimeout(() => {
                    $('body,.page-content').removeClass('hide-overflow fixed');

                    $('body').css('padding-right', '0px');
                    // toggleModal('modal-share', false);
                    $('[data-share]').focus();
                }, 100);
            }
        );
    },
};

export default Share;
